import { render } from "./ABadge.vue?vue&type=template&id=09fea3c8"
import script from "./ABadge.vue?vue&type=script&lang=js"
export * from "./ABadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__